import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import BrandHeader from './components/BrandHeader';
import './App.css';

const PAGES = [
    { to: '/ProductList', label: 'Company List' },
    { to: '/New_Product', label: 'New Products' },
];

/**
 * Header for the public product pages.
 *
 * Replaces the old .product_header / #S / .R markup (which squashed the square
 * brand mark to 70x80 and floated the partner logo up with a negative margin)
 * and the .lists nav, which rendered bare <li> elements inside a <div> wrapped
 * in a <Link> - invalid nesting, and it lost the active page.
 */
export default function Header() {
    const { pathname } = useLocation();

    return (
        <>
            <BrandHeader />

            <nav className='pageNav'>
                <ul className='pageNavList'>
                    {PAGES.map((p) => (
                        <li key={p.to}>
                            <Link
                                to={p.to}
                                className={pathname === p.to ? 'pageNavActive' : ''}
                            >
                                {p.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>
        </>
    );
}
